<!-- common certificate -->

<template>
  <div class="common-certificate" :style="businessCode?businessCodeStyle:''">
    <div class="certificate-see" v-html="htmls"></div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        IP360: {},
        keyList: {},
        certificate: {
          list: {},
          type: '',
        },
        businessCode:'',
        //流程存证（存证一体）证书样式
        businessCodeStyle:{
          'margin-left':'50%',
          'transform':'translateX(-50%)'
        },
        htmls:``
      }
    },
    props: ['certificateType', 'certificateList'],
    mounted () {
      this.$store.commit('showLoading', true);
      this.businessCode=this.$route.query.businessCode;
      this.IP360 = JSON.parse(window.localStorage.getItem('IP360'))
    },
    methods: {
    },
    watch:{
      certificateList (curVal, oldVal) {
        if (curVal) {
          this.certificate.list = curVal;
           //存证type6，7
          if(this.$route.query.type ==6 || this.$route.query.type ==7 || this.$route.query.type ==8){
            //是否显示证据 previewCertificateTitle-1显示，wl不显示（证书样式居中）
            this.businessCode=curVal.previewCertificateTitle==1?'':'wl';
          }
          this.certificate.list.summary? this.certificate.list.summary = JSON.parse(curVal.summary):'';
          this.htmls=curVal.htmlUrl;
          // this.initKey()
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  /* 目前证书 */
  .common-certificate {
    float: left;
  }
  .certificate-see{
    width: 470px;
    height: 690px;
    overflow-y: auto;
    overflow-x: hidden;
    margin-top: 32px;
  }
  .certificate-see::-webkit-scrollbar{
    width: 3px;
    background: #eee;
  }
  .certificate-see::-webkit-scrollbar-track{
    opacity: 0;
  }
  .certificate-see::-webkit-scrollbar-thumb{
    width: 3px;
    background: #ccc;
  }
  /* .certificate{
    background-image: url(../../assets/images/common/certificate_v4.png);
    background-position: center;
    background-repeat: no-repeat;
  } */
  
</style>
